<template>
  <div class="box" id="FAQManage">
    <div class="left-box">
      <div class="head-box">
        <h4>FAQ管理</h4>
        <div class="c-flex">
          <!--
          <i class="el-icon-circle-plus-outline c-pointer" @click="orgAdd"></i>
          <i class="el-icon-edit c-pointer c-m-l-15" @click="orgEdit"></i>
          <i class="el-icon-delete c-pointer c-m-l-15" @click="orgDelete"></i>
          -->
        </div>
      </div>
      <div class="left-content tree">
        <el-tree
          refs="tree"
          ref="tree"
          :data="treeData"
          node-key="_id"
          default-expand-all
          :indent="20"
          highlight-current
          :expand-on-click-node="false"
          @node-click="orgClick"
          :props="defaultProps"
          :current-node-key="expandedkeys"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span style="font-size:14px">
              {{ data.name }}
              <div class="wp">
                <i
                  :class="`${activeOrg._id == data._id ? '' : 'isShow'} el-icon-edit c-pointer`"
                  @click="orgEdit(data)"
                ></i>
                <i
                  :class="
                    `${activeOrg._id == data._id ? '' : 'isShow'} el-icon-delete c-pointer c-m-l-15`
                  "
                  @click="orgDelete(data)"
                ></i>
                <i class="el-icon-circle-plus-outline c-pointer c-m-l-15" @click="orgAdd(data)"></i>
              </div>
            </span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="服务团队"
                placement="top-start"
              ></el-tooltip>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <el-dialog title="FAQ菜单" :visible.sync="orgDialog" width="500px">
      <el-form :model="editOrg">
        <el-form-item label="FAQ类型名称" label-width="100px">
          <el-input v-model="editOrg.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="orgSave(editOrg)">确 定</el-button>
        <el-button @click="orgDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <div class="right-box">
      <div class="head-box">
        <h4>问题信息列表</h4>
        <div class="c-flex">
          <el-input
            placeholder="请输入问题进行搜索"
            v-model="searchValue"
            clearable
            @clear="
              fpi.page = 1;
              getUsers();
            "
            @keyup.enter.native="
              fpi.page = 1;
              getUsers();
            "
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click.native="
                fpi.page = 1;
                getUsers();
              "
            ></el-button>
          </el-input>
          <!-- <el-button type="primary" class="c-m-l-10">批量导入</el-button> -->
          <el-button type="primary" class="c-m-l-10" @click.native="userAdd">新建FAQ</el-button>
          <el-button class="c-m-l-10" @click.native="removeList">批量删除</el-button>
        </div>
      </div>
      <div class="content-box">
        <div class="content-table">
          <el-table
            ref="table"
            :data="fpi.data"
            empty-text="暂无信息"
            height="calc(100% - 50px)"
            @selection-change="handleSelectionChange"
            highlight-current-row
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column fixed="right" width="100px">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button>
                    操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="userEdit(scope.row)">编辑</el-dropdown-item>
                    <el-dropdown-item @click.native="userDelete(scope.row)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column label="问题" width="280" fixed="left">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click.native.prevent="
                    editUser = $util.deepCopy(scope.row);
                    userShowDialog = true;
                  "
                >
                  {{ scope.row.title }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="categoryId"
              label="分类"
              width="180"
              :formatter="formatterType"
            ></el-table-column>
            <el-table-column
              prop="content"
              label="解答"
              width="700px"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="pageSizeChange"
            @current-change="pageChange"
            :current-page="fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="fpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="fpi.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="问题信息" :visible.sync="userDialog" width="500px">
      <el-form
        :model="editUser"
        ref="user"
        :rules="rules"
        label-width="100px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="选择分类" prop="categoryId">
          <el-cascader
            v-model="editUser.categoryId"
            :options="treeDataOptions"
            :props="{
              value: '_id',
              label: 'name',
              children: 'childrens',
              checkStrictly: true
            }"
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="问题(Q)" prop="title">
          <el-input v-model="editUser.title"></el-input>
        </el-form-item>
        <el-form-item label="解答(A)" prop="content">
          <el-input
            v-model="editUser.content"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="userSave()">确 定</el-button>
        <el-button @click="userDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="问题信息" id="userShowDialog" :visible.sync="userShowDialog" width="500px">
      <div class="showCell">
        <span>分类：</span>
        <span>{{ editUser.categoryId }}</span>
      </div>
      <div class="showCell">
        <span>问题(Q)：</span>
        <span>{{ editUser.title }}</span>
      </div>
      <div class="showCell">
        <span>解答(A)：</span>
        <span>{{ editUser.content }}</span>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="userShowDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'orgUser',
  data() {
    return {
      tenantID: '', //租户id
      activeTab: 'org', //当前激活tab
      orgDialog: false,
      activeOrg: {}, //当前选中组织
      editOrg: '', //当前编辑的组织
      treeData: [], //所有菜单树节点
      defaultProps: {
        children: 'childrens',
        label: 'name'
      },
      userDialog: false, //是否显示编辑
      userShowDialog: false, //展示信息
      searchValue: '', //搜索关键词
      fpi: {}, //问题信息列表
      editUser: {}, //编辑信息
      edit: false, //新增false 编辑true
      rules: {
        categoryId: [
          {
            required: true,
            message: '分类不能为空',
            trigger: ['blur', 'change']
          }
        ],
        title: [
          {
            required: true,
            message: '问题(Q)不能为空',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '解答(A)内容不能为空',
            trigger: 'blur'
          }
        ]
      },
      treeDataOptions: [], //选择FAQ分类,
      delList: [], //批量信息列表
      formatterTypeArr: [], //反显信息表的分类
      expandedkeys: '' //默认选中菜单树
    };
  },
  mounted() {
    window.$this = this;
    this.tenantID = JSON.parse(sessionStorage['entity']).tenantId;

    // let org = {};
    // org.name = "全部FAQ";
    // org.parentId = 0;
    // org.tenantId = 0;
    // org.type = 1; //FAQ  //2 企业公告
    // this.osg.ajax("documentCategory/upsert.do", org, res => {});
    this.getOrg();
    this.osg.getFpi();
    this.getUsers();
  },
  methods: {
    //页码变更
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getUsers();
    },
    //当前页变更
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getUsers();
    },
    //添加组织
    orgAdd(data) {
      if (this.isSeveral(data) >= 3) {
        this.osg.toast('只允许创建三级目录！', 'warning');
        return;
      } else {
        this.editOrg = {};
        this.orgDialog = true;
      }
    },
    //点击组织
    orgClick(obj) {
      this.activeOrg = this.$util.deepCopy(obj);
      this.getUsers();
    },
    //获取组织
    getOrg() {
      this.osg.ajax('documentCategory/query.do', { type: 1 }, res => {
        let data = [res.entity];
        this.treeData = data;
        this.treeDataOptions = this.removeEmpty(
          res.entity && res.entity.childrens ? res.entity.childrens : []
        );

        this.$nextTick(() => {
          this.expandedkeys = this.activeOrg._id || res.entity._id;
          this.activeOrg = { _id: this.expandedkeys };
          this.$refs.tree.setCurrentKey(this.expandedkeys);
        });

        this.formatterTypeArr = [];
        this.myFlat(this.treeDataOptions);
      });
    },
    //编辑组织组织
    orgEdit(data) {
      if (this.isSeveral(data) == 1) {
        this.osg.toast('根目录不能进行编辑！', 'warning');
        return;
      }
      this.editOrg = this.activeOrg;
      this.orgDialog = true;
    },
    // 保存组织
    orgSave() {
      if (!this.editOrg.name) {
        this.osg.toast('请输入菜单名称！', 'error');
        return;
      }
      var org = this.editOrg;
      org.parentId = org.parentId || this.activeOrg._id || 0;
      org.tenantId = this.tenantID;
      org.type = 1;
      delete org.childrens;
      this.osg.ajax('documentCategory/upsert.do', { data: JSON.stringify(org) }, res => {
        this.osg.toast('保存成功！');
        this.orgDialog = false;
        this.getOrg();
      });
    },
    // 删除空数组
    removeEmpty(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item.childrens ? item.childrens.length === 0 : false) {
            delete item.childrens;
          } else {
            this.removeEmpty(item.childrens);
          }
        });
        return arr;
      }
    },
    // 判断当前被选中的节点在第几层数组
    isSeveral(obj) {
      return this.treeData
        .map(item => {
          if (item._id == obj._id) {
            return 1;
          }
          return !item.childrens
            ? []
            : item.childrens.map(ele => {
                if (ele._id == obj._id) {
                  return 2;
                }
                return !ele.childrens
                  ? []
                  : ele.childrens.map(el => {
                      if (el._id == obj._id) {
                        return 3;
                      }
                    });
              });
        })
        .flat(Infinity)
        .join('');
    },
    // 解析菜单
    myFlat(arr) {
      // this.formatterTypeArr=
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          this.formatterTypeArr.push(item);
          if (item.childrens ? item.childrens.length : false) {
            this.formatterTypeArr.push(...item.childrens);
          }
        });
      }
    },
    //删除菜单节点
    orgDelete(data) {
      if (this.isSeveral(data) == 1) {
        this.osg.toast('根目录不能删除 ！', 'warning');
        return;
      } else {
        this.osg.confirm(`是否确认删除"${this.activeOrg.name}"`, () => {
          this.osg.ajax(`documentCategory/remove/${this.activeOrg._id}.do`, {}, res => {
            this.osg.toast('删除成功！');
            this.searchValue = '';
            this.getOrg();
            this.getUsers();
          });
        });
      }
    },
    //获取信息列表
    getUsers() {
      var params = {
        'regex:title|string#and': this.searchValue,
        'is:type|integer#and': 1,
        'is:categoryId|string#and':
          this.isSeveral(this.activeOrg) == 1 ? '' : this.activeOrg._id || '',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.setFpi(params);
      this.osg.ajax('document/query.do', params, res => {
        if (res) {
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        }
      });
    },
    //添加信息按钮
    userAdd() {
      this.edit = false;
      this.editUser = {};
      this.editUser.categoryId = this.activeOrg._id;
      this.userDialog = true;
    },
    //编辑信息按钮
    userEdit(row) {
      this.edit = true;
      this.editUser = this.$util.deepCopy(row);
      this.userDialog = true;
    },
    //保存FAQ信息
    userSave() {
      let pass;
      this.$refs['user'].validate(valid => {
        if (valid) pass = true;
      });
      if (!pass) return;
      let editUser = this.$util.deepCopy(this.editUser);
      editUser.type = 1;
      editUser.tenantId = this.tenantID;
      editUser.categoryId = Array.isArray(editUser.categoryId)
        ? editUser.categoryId[editUser.categoryId.length - 1]
        : editUser.categoryId;
      this.osg.ajax('document/upsert.do', editUser, res => {
        this.osg.toast('保存成功');
        this.userDialog = false;
        this.getUsers();
      });
    },
    //删除FAQ信息
    userDelete(row) {
      this.osg.confirm('是否确认删除 ' + row.title + '？', () => {
        this.osg.ajax(`document/remove/${row._id}.do`, null, res => {
          this.osg.toast('删除成功！');
          this.getUsers();
        });
      });
    },
    //批量删除
    removeList() {
      if (!this.delList.length) {
        this.osg.toast('请勾选要删除的信息列表！', 'warning');
        return;
      }
      this.osg.confirm('是否确认删除 ？', () => {
        let dataArr = this.delList.map(item => item._id);
        this.osg.ajax(
          'document/batchRemove.do',
          { dList: JSON.stringify(dataArr) },
          res => {
            if (res) {
              this.osg.toast('删除成功！');
              this.getUsers();
              this.getOrg();
            }
          }
          // { header: { "Content-Type": "application/json" } }
        );
      });
    },
    //被勾选上的问题信息列表
    handleSelectionChange(val) {
      this.delList = val;
    },
    formatterType(row, column, cellValue, index) {
      return this.formatterTypeArr
        .map(item => {
          if (item._id == cellValue) return item.name;
        })
        .join('');
    }
  }
};
</script>
<style scoped>
.showCell {
  margin: 0 40px 10px 10px;
  display: flex;
  align-items: center;
}
.showCell > span:nth-of-type(1) {
  width: 80px;
  line-height: 30px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
.isShow {
  display: none;
}
.wp {
  position: absolute;
  top: 50%;
  right: 36px;
  transform: translateY(-50%);
}
</style>
<style>
#FAQManage .el-tree-node__content {
  position: relative;
}
</style>
